<template>
    <b-row>
		<b-col cols="12">
			<b-form-row>
				<b-col v-if="!hideLabel" :cols="labelSize" style="word-break: break-all;">
					<label class="col-form-label  pt-0 col-form-label-sm  pt-0">{{ label}} <span v-if="required" class="text-danger">*</span></label>
				</b-col>
				<b-col :cols="fieldSize">
					<b-form-group>
						<b-input-group class="shodowed-group">
							<b-form-select
										   :plain="false"
										   v-model="localValue"
										   :options="options"
										   :value-field="'id'"
										   size="sm"
										   :disabled="disabled"
										   :state="isValid"
										   class="creatable-select"
										   :text-field="'name'"
							>
								<template slot="first">
									<option :value="null">-- {{label}} --</option>
								</template>
							</b-form-select>
							<b-input-group-append>
								<b-input-group-addon>
									<b-button type="button"
											  size="sm"
											  :disabled="disabled"
											  variant="outline-default"
											  v-b-modal.modal-add
											  @click="createNew">
										<i class="fa fa-plus"></i>
									</b-button>
								</b-input-group-addon>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
					<vs-sidebar v-if="!isForContragent"  position-right  parent="body" default-index="1"  color="primary" class="create-item" spacer v-model="createItem">
						<b-container index="1">
							<create-reference v-if="isReference" :parent-name="parentName"
											  @close="createItem = false"
											  @reload="reload"
											  @value="setValue($event)"
											  :parent-code="parentCode">
							</create-reference>
							<contr-agent-form
								v-if="isAgent"
								@close="createItem = false"
								:parent-name="label"
							></contr-agent-form>
						</b-container>
					</vs-sidebar>
				</b-col>
			</b-form-row>
		</b-col>
	</b-row>
</template>

<script>
    import CreateReference from "../references/blocks/CreateReference";
	import ContrAgentForm from "../references/blocks/ContrAgentForm";

	export default {
        name: 'SelectOrCreate',

		props: {
        	/* Bakhtiyor added begin */
			isForContragent: {
				type: Boolean,
				default: false
			},
        	/* Bakhtiyor added end */
        	name: {
        		type: String
			},
        	value: {
			},
			options: {
        		type: Array,
				default: []
			},
			parentCode: {},
			parentName: {},
			label: {
        		type: String,
				default:''
			},
			hideLabel: {
        		type: Boolean,
				default: false
			},
			labelSize: {
        		type: Number,
				default: 2
			},
			fieldSize: {
				type: Number,
				default: 10
			},
			module: {
        		type: String,
				default: 'reference'
			},
			states: {
			},
			required: {
        		default: false
			},
			disabled: {
        		default: false
			}
		},

		data() {
        	return {
        		localValue: this.value ? this.value : null,
				createItem: false,
			}
		},

		watch: {
			value(newVal, oldVal) {
				this.localValue = newVal
			},
			localValue(newVal, oldVal) {
				this.$emit('input', this.localValue)
			}
		},

		methods: {
        	createNew() {
        		if (this.isForContragent) {
        			this.$emit('showNestedModal', this.parentName)
				} else {
					setTimeout(() => {
						this.createItem = true;
					}, 200);
					this.$emit('not-close', true)
				}
			},
			reload() {
				this.$emit('reload', true);
			},
			setValue($event) {
				this.localValue = $event.id;
			},

			close() {
				this.createItem = true;
				this.$emit('not-close', false)
			}

		},

		components: {
			CreateReference,
			ContrAgentForm
		},
		computed: {
        	isReference() {
        		return this.module === 'reference';
			},
			isAgent() {
        		return this.module === 'contrAgent';
			},
			isValid() {
        		if (this.states && this.isChanged) {
        			return  this.states.valid;
				}
        		return null;
			},
			isChanged() {
        		return this.states.dirty
			}
		}
	}
</script>

<style scoped>

</style>
